import { IconButton } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import {
  DynamicForm,
  LoggerFactory,
  Schema,
  SecurityProvider
} from "lego-gui-lib";
import { FlatForm } from "lego-gui-lib/lib/components/Views/ShowView/FlatForm";
import React, { ReactText, useContext } from "react";
import { Form, FormRenderProps } from "react-final-form";
import { DialogContentContainer } from "../../../../../common/dialogContainers";
import { FormState } from "final-form";
import { reaction } from "mobx";
import { createStyles, makeStyles, Theme } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import { treeBlockOutputsContext } from "../../schema";
import { TreeBlockType } from "../../TreeBlockType";
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      justifySelf: "end",
      maxWidth: "30px",
      maxHeight: "30px",
      marginTop: theme.spacing(2)
    },
    root: {
      gridTemplateColumns: "auto auto",
      height: "70px",
      minHeight: "48px"
    },
    gridFieldWrapper: {
      display: "grid",
      gridTemplateColumns: "35% 65%"
    },
    gridField: {
      maxHeight: "48px"
    }
  })
);

interface OutputFormProps {
  blockType: TreeBlockType;
  schema: Schema;
  treeBlockId: ReactText;
  handleAddOutputToList: (
    blockId: ReactText,
    blockType: TreeBlockType,
    output: any
  ) => void;
}

export const OutputForm = observer((props: OutputFormProps) => {
  const { schema, treeBlockId, blockType, handleAddOutputToList } = props;
  const outputsContext = useContext(treeBlockOutputsContext);
  const log = LoggerFactory.create("OutputForm");

  const classes = useStyles();

  const submit = (value: string, form: any): void => {
    handleAddOutputToList(treeBlockId, blockType, value);
    /* Reset form after submit */
    setTimeout(() => {
      form.reset();
    }, 10);
    form.resetFieldState("output");
  };

  const changed = (formState: FormState<any>): void => {
    log.debug("changed", formState);
  };

  const dynamicForm = (formRenderProps: FormRenderProps<any>) => {
    reaction(
      () => outputsContext.formOutputType,
      () => {
        log.debug("outputType reaction", outputsContext.formOutputType);
        formRenderProps.form.reset();
      }
    );

    return (
      <SecurityProvider security={schema.security}>
        <DynamicForm
          classes={{
            root: classes.root,
            gridFieldWrapper: classes.gridFieldWrapper,
            gridField: classes.gridField
          }}
          {...formRenderProps}
          fields={schema}
          Presentation={FlatForm}
          values={formRenderProps.values}
          model={{}}
          onChange={changed}
        >
          <IconButton
            size={"small"}
            className={classes.button}
            type="submit"
            color="primary"
          >
            <Add />
          </IconButton>
        </DynamicForm>
      </SecurityProvider>
    );
  };

  return (
    <DialogContentContainer>
      <Form onSubmit={submit} render={dynamicForm} />
    </DialogContentContainer>
  );
});
